import React from 'react'

import { get } from 'lodash'

import httpClient, { catchError } from '@emmacare/common/api/httpClient'

import {
  setClinicianUserRoles,
  setCliniciansList,
  setCliniciansLoader,
  setCliniciansModalLoader
} from 'src/store/modules/admin'

import {
  CHECK_CLINICIAN_CALENDAR,
  CLINICIANS,
  UNLOCK_CLINICIAN,
  UPDATE_CLINICIAN,
  USER_ROLES_LIST
} from 'src/constants'
import { showErrorModal } from 'src/services/dialogs'

export const getClinicians = (query, isCalendar) => async (dispatch) => {
  dispatch(setCliniciansLoader(true))
  try {
    const { items, meta } = await httpClient.request({
      method: 'get',
      url: {
        pathname: CLINICIANS,
        query
      }
    })

    if (isCalendar) {
      return {
        calendar: get(items, [0, 'customCalendar', 'days']),
        clinicianName: get(items, [0, 'fullName'])
      }
    }

    dispatch(setCliniciansList(items))
    return meta
  } catch (err) {
    catchError(err)
  } finally {
    dispatch(setCliniciansLoader(false))
  }
}

export const createClinician = (payload, query) => async (dispatch) => {
  dispatch(setCliniciansModalLoader(true))
  try {
    await httpClient.request({
      method: 'post',
      url: {
        pathname: CLINICIANS
      },
      payload
    })
    await dispatch(getClinicians(query))
    return false
  } catch (err) {
    const { errors, message } = err

    if (message && !errors) {
      catchError(err)
    }

    if (errors) {
      const content = (
        <div>
          {Object.keys(errors).map((key) => (
            <span style={{ marginBottom: '10px' }} key={key}>
              {errors[key][0]}
              <br />
            </span>
          ))}
        </div>
      )

      showErrorModal({
        title: 'Validation Error',
        content
      })
    }

    return err
  } finally {
    dispatch(setCliniciansModalLoader(false))
  }
}

export const updateClinician =
  (payload, uuid, query, unlock) => async (dispatch) => {
    dispatch(setCliniciansModalLoader(true))
    try {
      if (unlock) {
        dispatch(unlockClinician(uuid))
      }

      await httpClient.request({
        method: 'patch',
        url: {
          pathname: UPDATE_CLINICIAN,
          params: {
            uuid
          }
        },
        payload
      })
      await dispatch(getClinicians(query))
      return false
    } catch (err) {
      const { errors, message } = err

      if (message && !errors) {
        catchError(err)
      }

      if (errors) {
        const content = (
          <div>
            {Object.keys(errors).map((key) => (
              <span style={{ marginBottom: '10px' }} key={key}>
                {errors[key][0]}
                <br />
              </span>
            ))}
          </div>
        )

        showErrorModal({
          title: 'Validation Error',
          content
        })
      }
      return err
    } finally {
      dispatch(setCliniciansModalLoader(false))
    }
  }

export const updateClinicianCalendar = (payload, uuid) => async () => {
  try {
    await httpClient.request({
      method: 'patch',
      url: {
        pathname: UPDATE_CLINICIAN,
        params: {
          uuid
        }
      },
      payload
    })
  } catch (err) {
    catchError(err)
  }
}

export const checkClinicianCalendar = async (payload, uuid) => {
  try {
    const res = await httpClient.request({
      method: 'post',
      url: {
        pathname: CHECK_CLINICIAN_CALENDAR,
        params: {
          uuid
        }
      },
      payload
    })

    return res
  } catch (err) {
    catchError(err)
    return false
  }
}

export const getClinicianUserRoles = () => async (dispatch) => {
  try {
    const { items } = await httpClient.request({
      method: 'get',
      url: {
        pathname: USER_ROLES_LIST,
        query: {
          clinicianRoles: 1
        }
      }
    })

    dispatch(setClinicianUserRoles(items))
  } catch (err) {
    catchError(err)
  }
}

export const unlockClinician = (uuid) => async () => {
  try {
    await httpClient.request({
      method: 'post',
      url: {
        pathname: UNLOCK_CLINICIAN,
        params: { uuid }
      }
    })
    return false
  } catch (err) {
    catchError(err)
  }
}
